module.exports = __webpack_public_path__ + "img/world.ba0e50c9.png";